module.exports = __webpack_public_path__ + "media/large/real_estate_townhomes_rent-281a13a8.jpeg";